import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root',
})
export class CanSeeLoginPageGuard {
  private readonly _auth = inject(AuthService);
  private readonly _router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    // Wait for the session to be restored, then keep authenticated users off
    // the login/signup pages — straight to their dashboard (not via `/`,
    // which would just redirect to /home again).
    return this._auth.isLoading$.pipe(
      filter((loading) => !loading),
      take(1),
      switchMap(() => this._auth.isAuthenticated$),
      take(1),
      map((isAuthenticated) =>
        isAuthenticated ? this._router.parseUrl('/home') : true,
      ),
    );
  }
}
